import { isEmpty } from "../../services/utils";
import { removeToolTipFromStore } from "../../utils/tooltiphelper";
import useTooltipStore from "../../zustandStores/TooltipStore";
import TooltipObserver from "./TooltipObserver";
const TooltipScheduler = () => {
  const currentTooltipList = useTooltipStore(state => state.currentTooltipList);
  const currentObservedTooltips = useTooltipStore(
    state => state.currentObservedTooltips
  );
  const setCurrentObservedTooltips = useTooltipStore(
    state => state.setCurrentObservedTooltips
  );
  const getTopProrityTooltip = () => {
    const { currentTooltipList } = useTooltipStore.getState();
    return currentTooltipList.reduce((prev, current) => {
      return prev.priority < current.priority ? prev : current;
    });
  };
  setTimeout(() => {
    const { currentTooltipList, currentObservedTooltips } =
      useTooltipStore.getState();
    const topPriorityTooltip = currentTooltipList.length
      ? getTopProrityTooltip()
      : {};
    if (!isEmpty(topPriorityTooltip)) {
      if (
        !currentObservedTooltips?.tooltipId &&
        topPriorityTooltip.id !== currentObservedTooltips?.tooltipId
      ) {
        TooltipObserver.attach(
          topPriorityTooltip.id,
          topPriorityTooltip.expiry ?? 360
        )
          .then(() => {
            setCurrentObservedTooltips(topPriorityTooltip.id);
          })
          .catch(err => {
            removeToolTipFromStore({ id: topPriorityTooltip.id });
            console.log("error", err);
          });
      }
    }
  }, 100);

  return <></>;
};
export default TooltipScheduler;
